import { render, staticRenderFns } from "./WalletAmountStat.vue?vue&type=template&id=5927bcde&"
import script from "./WalletAmountStat.vue?vue&type=script&lang=js&"
export * from "./WalletAmountStat.vue?vue&type=script&lang=js&"
import style0 from "./WalletAmountStat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports